export default __webpack_public_path__ + "assets/images/avatar.efc924.png";